class Header {
  constructor() {
    this.desktopBp = window.matchMedia(`(min-width: ${window.breakpoints.desktop})`);
    this.els();
    this.listeners();
    this.toggleNavDetails();
  }

  els() {
    this.mobileMenuSearch = document.querySelector('#mobileMenuSearchMenuQuery');
    this.$mobileMenuAccordionToggles = document.querySelectorAll('[data-menu-accordion-toggle]');
    this.$navDetails = document.querySelector('#navDetails');
    this.$navToggle = document.querySelector('#navSummary');
    this.$searchMenu = document.querySelector('#searchMenu');
    this.$searchMenuQuery = document.querySelectorAll('[data-search-menu-query]');
    this.$submenuToggles = document.querySelectorAll('[data-menu-toggle]');
    this.$touchSubmenuToggles = document.querySelectorAll('[data-nav-menu-toggle]');
  }

  listeners() {
    window.subscribe(PUB_SUB_EVENTS.navClose, event => {
      this.close();
    });

    window.subscribe(PUB_SUB_EVENTS.navOpen, event => {
      this.open();
    });

    this.desktopBp.addEventListener('change', () => {
      this.toggleNavDetails();
    });

    this.$mobileMenuAccordionToggles.forEach(el => {
      el.addEventListener('click', e => {
        this.mobileMenuAccordionToggle(e);
      })
    });

    this.$navToggle.addEventListener('click', e => {
      e.preventDefault();
      this.navToggle(e);
    });

    this.$submenuToggles.forEach(el => {
      el.addEventListener('click', e => {
        this.submenuToggle(e);
      })
    });

    this.$touchSubmenuToggles.forEach(el => {
      el.addEventListener('click', e => {
        this.touchSubmenuToggle(e);
      })
    });

    document.addEventListener('onEsc', () => {
      const $menuActive = document.querySelector('.menu-active');

      if (this.desktopBp.matches) {
        // close touch/keyboard activated menu
        if ($menuActive) $menuActive.querySelector('[data-menu-toggle]').click();
      } else {
        // close mobile menu
        if (document.documentElement.classList.contains('mobile-menu--active')) this.$navToggle.click();
      }
    });
  }

  close(els) {
    els = typeof els !== 'undefined' ? els : document.querySelectorAll('body > *:not(.header-group):not(.uwy), .header > *:not(.nav__details):not(.header__logo), .nav__summary, #searchMenuToggle');
    this.$navDetails.removeAttribute('data-nav-inert');
    if (!this.desktopBp.matches) navDetails.removeAttribute('open');

    // untrap focus
    els.forEach(el => {
      el.removeAttribute('data-nav-inert');
      el.removeAttribute('inert');
    });

    lockScrollDisable();

    // close open menus
    document.querySelectorAll('.menu-active').forEach(el => {
      el.querySelector('[data-menu-toggle]').click();
    });

    requestAnimationFrame(() => {
      window.menuToggling = false;

      setTimeout(() => {
        document.documentElement.classList.remove('suggestions--active');
      }, 250);
    });
  }

  open(els) {
    // els = typeof els !== 'undefined' ? els : document.querySelectorAll('body > *:not(.header-group), .header-group > *:not(.header), .header__logo, .nav__icons, #searchMenuToggle');
    lockScrollEnable();
    this.$navDetails.setAttribute('open', true);

    document.documentElement.classList.remove('search-menu--active', 'suggestions--active');

    nav.scroll(0, 0);
    document.querySelectorAll('.nav__menu').forEach(el => el.scroll(0, 0));

    // trap focus
    // if (els) {
    //   els.forEach(el => {
    //     el.setAttribute('data-nav-inert', true);
    //     el.setAttribute('inert', true);
    //   });
    // }

    if (window.headerScrolled) document.documentElement.classList.add('header--scrolled');
    if (window.headerScrolledMobile) document.documentElement.classList.add('header--scrolled-mobile');
  }

  // make desktop dropdowns work with touch screens
  touchSubmenuToggle(event) {
    if (this.desktopBp.matches && document.documentElement.classList.contains('touch')) {
      event.preventDefault();

      const $menuItem = event.target.closest('[data-nav-menu]');
      if (!$menuItem) return;

      const $openMenu = document.querySelector('[data-nav-menu].menu-active');

      if ($openMenu && $openMenu !== $menuItem) {
        $openMenu.classList.remove('menu-active');
        $openMenu.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', false);
      }

      $menuItem.classList.toggle('menu-active');
    }
  }

  // toggle mobile menu
  navToggle(event) {
    window.menuToggling = true;
    event.preventDefault();

    document.documentElement.classList.toggle('mobile-menu--active');

    const els = document.querySelectorAll('body > *:not(.header-group):not(.uwy), .header > *:not(.nav__details):not(.header__logo), .nav__summary, #searchMenuToggle');
    const isOpen = document.documentElement.classList.contains('mobile-menu--active');

    setTimeout(() => {
      if (isOpen) {
        this.open(els);
      } else {
        this.close(els);
      }
    }, !isOpen ? 250 : 0);
  };

  // mobile second level back buttons + desktop keyboard toggle buttons
  submenuToggle(event) {
    const $menuItem = event.target.closest('[data-nav-menu]');
    const $openMenu = document.querySelector('[data-nav-menu].menu-active');

    if (event.target.closest('.nav__footer')) event.target.closest('.nav__footer').classList.toggle('has-menu-active');

    if ($openMenu && $openMenu !== $menuItem) {
      $openMenu.classList.remove('menu-active');
      $openMenu.querySelector('[data-menu-toggle]').setAttribute('aria-expanded', false);
    }

    nav.scroll(0, 0);
    document.querySelectorAll('.nav__menu').forEach(el => el.scroll(0, 0));

    $menuItem.classList.toggle('menu-active');
    event.target.setAttribute('aria-expanded', $menuItem.classList.contains('menu-active'));
    nav.classList[$menuItem.classList.contains('menu-active') ? 'add' : 'remove']('nav--submenu-open');
    // const $submenuTrapEls = document.querySelectorAll('#navSummary, .nav > *:not(.menu-active):not(#mobileMenuClose):not(.nav__footer.has-menu-active):not(#mobileMenuSearchForm):not(search-menu), .nav__footer.has-menu-active > *:not(.menu-active)');
    // if (this.desktopBp.matches) return;
    // if ($menuItem.classList.contains('menu-active')) {
    //   // trap focus
    //   $submenuTrapEls.forEach(el => {
    //     el.setAttribute('data-subnav-inert', true);
    //     el.setAttribute('inert', true);
    //   });
    // } else {
    //   // untrap focus
    //   document.querySelectorAll('[data-subnav-inert]').forEach(el => {
    //     el.removeAttribute('data-subnav-inert');
    //     el.removeAttribute('inert');
    //   });
    // }
  };

  mobileMenuAccordionToggle(event) {
    if (this.desktopBp.matches) return;

    event.preventDefault();

    const $menu = event.target.closest('[data-menu-group]');
    if (!$menu) return;

    $menu.classList.toggle('active');

    if ($menu.classList.contains('active')) {
      $menu.setAttribute('open', '');
    } else {
      $menu.removeAttribute('open');
    }
  }

  // open nav <details> element for desktop viewports
  toggleNavDetails() {
    if (this.desktopBp.matches) {
      // add open attribute to nav details el for desktop screens
      this.$navDetails.setAttribute('open', true);

      // close mobile menu
      if (document.documentElement.classList.contains('mobile-menu--active')) {
        this.$navClose.click();
      }
    } else {
      this.$navDetails.removeAttribute('open');
    }
  }
}

new Header()
